@if (vm$ | async; as vm) {
    @if (isEpcotEnabled) {
        <button class="cancel-picks-button-epcot" ds-button-icon kind="secondary" size="small" variant="outline" (click)="close()">
            <vn-icon name="theme-ex" size="9" />
        </button>
    } @else {
        <button class="cancel-picks-button" ds-button-icon size="medium" variant="flat" kind="tertiary" (click)="close()">
            <vn-icon name="theme-ex" size="16" />
        </button>
    }
    @if (isSinglePick()) {
        <bs-quick-bet-single-pick
            [pick]="singlePick()"
            [oddsDisplayFormat]="oddsDisplayFormat()"
            [isEpcotEnabled]="isEpcotEnabled"
            [singleBetId]="singleBetId()" />
    } @else {
        <bs-quick-bet-pick-list [isEpcotEnabled]="isEpcotEnabled" [picks]="pickList()" [oddsDisplayFormat]="oddsDisplayFormat()" />
    }
    <div
        class="quick-bet__inputs"
        [class.quick-bet__inputs-min-height]="quickBetConfig.isPossibleWinningsUnderStakeInputEnabled && vm.isReturnsVisible">
        @if (isFreeBetToken(vm.rewardToken)) {
            <bs-freebet-stake [freeBetToken]="vm.rewardToken" />
        } @else {
            <bs-quick-bet-stake class="quick-bet__input quick-bet__input--right" [adornmentStart]="getEachWayValue(vm.isEachWay)" />
        }
        @if (vm.underMinimumStakeError) {
            <span class="quick-bet__under-minimum-stake"
                >{{ sitecore.quickBetMessages.MinimumStake }} {{ vm.underMinimumStakeError.minimumStake | bsCurrency: true }}</span
            >
        } @else if (quickBetConfig.isPossibleWinningsUnderStakeInputEnabled && vm.isReturnsVisible) {
            <bs-quick-bet-total-returns [pickIds]="pickIds()" [isPossibleWinningsUnderStakeInput]="true" />
        }
    </div>
}
